
import { useState, useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputPESEL(props)
{
 

    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');


    const [onShow,setOnShow] = useState(false);
    

    const validate = (pesel) => {
 
            if (!/^\d{11}$/.test(pesel)) {
                return false; // Nie ma 11 cyfr
            }
        
            const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
            const digits = pesel.split('').map(Number);
            const controlSum = digits
                .slice(0, 10)
                .reduce((sum, digit, i) => sum + digit * weights[i], 0);
            
            const controlDigit = (10 - (controlSum % 10)) % 10;
        
            if (controlDigit !== digits[10]) {
                return false; // Nie zgadza się suma kontrolna
            }
        
            // Walidacja daty urodzenia (opcjonalna, ale przydatna)
            const year = parseInt(pesel.substring(0, 2), 10);
            const month = parseInt(pesel.substring(2, 4), 10);
            const day = parseInt(pesel.substring(4, 6), 10);
        
            // Dekodowanie pełnej daty urodzenia
            let fullYear;
            let realMonth;
        
            if (month >= 1 && month <= 12) {
                fullYear = 1900 + year;
                realMonth = month;
            } else if (month >= 21 && month <= 32) {
                fullYear = 2000 + year;
                realMonth = month - 20;
            } else if (month >= 41 && month <= 52) {
                fullYear = 2100 + year;
                realMonth = month - 40;
            } else if (month >= 61 && month <= 72) {
                fullYear = 2200 + year;
                realMonth = month - 60;
            } else if (month >= 81 && month <= 92) {
                fullYear = 1800 + year;
                realMonth = month - 80;
            } else {
                return false; // Błędny miesiąc
            }
        
            const date = new Date(fullYear, realMonth - 1, day);
            if (
                date.getFullYear() !== fullYear ||
                date.getMonth() !== realMonth - 1 ||
                date.getDate() !== day
            ) {
                return false; // Nieprawidłowa data
            }
        
            return true;
        }

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

        

         v = v.replace(/[^0-9]/g, '');       

         

        setVal(v);

        var correct = false;

        if(req == '1' ) 
        {
            if( v.length == 10) correct = true;                               
        }

        else
        {
            if( v.length == 0) correct = true; 
        }

        
        if(v.length > 0)
        {
              correct = validate(v);
        }
     
        
 
        
                        
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != null  &&  val != undefined ) 
        {
            if(val.length != 10 ) correct = false;                      
        }
    

        if(val != null  &&  val != undefined && val.length > 0)
        {
              correct = validate(val);
        }

      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }

    
    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })

     

 
    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }



    var cnX = cn;
    if( val != null && val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


    return <fieldset>        
        <input type="phone"  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={" w150  " + cnX} />        
        {imgx}
        <br/>
             <span className="form_err">{err + " "} &nbsp; </span>        
    </fieldset>
}


export default InputPESEL;